module.exports = __webpack_public_path__ + "img/green-title-bm.29a8a573.png";